import { useEffect, type FC, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown } from 'shared/ui'
import { availableHeight } from 'shared/lib'
import { type FiltersStore } from 'features/DropdownFilter'
import { FiltersAction, FiltersItems } from 'features/DropdownFilter/actions/Filters'

type IDropdownFilterProps = {
  store: FiltersStore
}

export const DropdownFilter: FC<IDropdownFilterProps> = observer(({ store }) => {
  const [toggle, setToggle] = useState(false)
  const { loadFilters, filters, loading, filter, reset, enableCount, count } = store

  useEffect(() => {
    loadFilters()

    return () => {
      reset()
    }
  }, [])

  return (
    <Dropdown
      ariaLabel={'DropdownFilter'}
      icon={'chatLayout'}
      placement={'bottom-start'}
      typeButton={'button'}
      tooltipProps={{
        label: 'Chat view',
        placement: 'bottom',
      }}
      items={[...FiltersItems(filters, store)]}
      onChange={(item) => {
        FiltersAction(item, store)
      }}
      buttonProps={{
        text: filter?.label,
        isRight: true,
        icon: toggle ? 'chevronUp' : 'chevronDown',
        typeBtn: 'text',
        contained: 'primary',
        countNumber: count,
        countEnable: enableCount,
        size: 'medium',
      }}
      onToggle={(status) => {
        setToggle(status)
      }}
      disabled={loading}
      PopperProps={{
        modifiers: [availableHeight('DropdownList_Items')],
      }}
    />
  )
})
